<template>
  <div :class="['view', containerClass]" :style="{ height: height }">
    <div class="view__panel" :style="{ flexGrow: leftFlex }">
      <div v-if="hasLeftHeader" class="view__header">
        <slot name="leftHeader"></slot>
      </div>
      <div class="view__body">
        <slot name="leftBody"></slot>
      </div>
    </div>
    <div class="view__panel" :style="{ flexGrow: rightFlex }">
      <div v-if="hasRightHeader" class="view__header">
        <slot name="rightHeader"></slot>
      </div>
      <div class="view__body">
        <slot name="rightBody"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    containerClass: [String, Array],
    hasLeftHeader: {
      type: Boolean,
      default: true
    },
    hasRightHeader: {
      type: Boolean,
      default: true
    },
    height: {
      type: String,
      default: '320px'
    },
    leftFlex: {
      type: Number,
      default: 1
    },
    rightFlex: {
      type: Number,
      default: 1
    }
  }
};
</script>

<style lang="scss" scoped>
.view {
  display: flex;
  align-items: stretch;

  &__panel {
    display: flex;
    flex-direction: column;
    flex: 1 0 0;
    // Needed to make flex children to stick to its flex value in cases when
    // content tries to stretch it beyound its limit
    min-width: 0;

    &:first-child {
      border-right: 1px solid $border-color;
    }
  }

  &__header {
    display: flex;
    align-items: center;
    padding: 0.5rem 1rem;
    border-bottom: 1px solid $border-color-dark;
    min-height: $split-view-header-min-height;
    flex: 0 0 0;

    /deep/ .header-title {
      flex: 1 0 0;
      margin-right: 0.5rem;
    }
  }

  &__body {
    flex: 1 0 0;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    overflow: auto;
  }
}
</style>
